// English strings (source language): data layer messages (API, synchronisation).

const en = {
  unreachable: 'Server unreachable',
  httpError: (status: number) => `Error ${status}`,
};
export default en;
